import _definePage_default_0 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-recommendations/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-requests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-settings/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-tests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agents/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/all-agent-tests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/billing/tariffs/index.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/bills/index.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/clients/index.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/consultation-requests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/consultations/specialists/index.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/dictionaries/index.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/feedbacks/index.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/mailings/email-templates/index.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/mailings/sms-templates/index.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/prepared-questions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/prompts/index.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/recommendations/directions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/recommendations/institutions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/refund-requests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/settings/admins/index.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/test-analytics/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/tests/index.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/builds/raildev/career-guidance/frontend/apps/admin/src/pages/users/index.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/agent-recommendations',
    /* internal name: '/agent-recommendations' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/agent-recommendations/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-recommendations/index.vue'),
          /* no children */
        },
        _definePage_default_2
      )
    ],
  },
  {
    path: '/agent-requests',
    /* internal name: '/agent-requests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/agent-requests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-requests/index.vue'),
          /* no children */
        },
        _definePage_default_3
      )
    ],
  },
  {
    path: '/agent-settings',
    /* internal name: '/agent-settings' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/agent-settings/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-settings/index.vue'),
          /* no children */
        },
        _definePage_default_4
      )
    ],
  },
  {
    path: '/agent-tests',
    /* internal name: '/agent-tests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/agent-tests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agent-tests/index.vue'),
          /* no children */
        },
        _definePage_default_5
      )
    ],
  },
  {
    path: '/agents',
    /* internal name: '/agents' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/agents/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/agents/index.vue'),
          /* no children */
        },
        _definePage_default_6
      )
    ],
  },
  {
    path: '/all-agent-tests',
    /* internal name: '/all-agent-tests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/all-agent-tests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/all-agent-tests/index.vue'),
          /* no children */
        },
        _definePage_default_7
      )
    ],
  },
  {
    path: '/billing',
    /* internal name: '/billing' */
    /* no component */
    children: [
      {
        path: 'tariffs',
        /* internal name: '/billing/tariffs' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/billing/tariffs/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/billing/tariffs/index.vue'),
              /* no children */
            },
            _definePage_default_8
          )
        ],
      }
    ],
  },
  {
    path: '/bills',
    /* internal name: '/bills' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/bills/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/bills/index.vue'),
          /* no children */
        },
        _definePage_default_9
      )
    ],
  },
  {
    path: '/clients',
    /* internal name: '/clients' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/clients/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/clients/index.vue'),
          /* no children */
        },
        _definePage_default_10
      )
    ],
  },
  {
    path: '/consultation-requests',
    /* internal name: '/consultation-requests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/consultation-requests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/consultation-requests/index.vue'),
          /* no children */
        },
        _definePage_default_11
      )
    ],
  },
  {
    path: '/consultations',
    /* internal name: '/consultations' */
    /* no component */
    children: [
      {
        path: 'specialists',
        /* internal name: '/consultations/specialists' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/consultations/specialists/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/consultations/specialists/index.vue'),
              /* no children */
            },
            _definePage_default_12
          )
        ],
      }
    ],
  },
  {
    path: '/dictionaries',
    /* internal name: '/dictionaries' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/dictionaries/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/dictionaries/index.vue'),
          /* no children */
        },
        _definePage_default_13
      )
    ],
  },
  {
    path: '/feedbacks',
    /* internal name: '/feedbacks' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/feedbacks/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/feedbacks/index.vue'),
          /* no children */
        },
        _definePage_default_14
      )
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/login/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/mailings',
    /* internal name: '/mailings' */
    /* no component */
    children: [
      {
        path: 'email-templates',
        /* internal name: '/mailings/email-templates' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/mailings/email-templates/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/mailings/email-templates/index.vue'),
              /* no children */
            },
            _definePage_default_15
          )
        ],
      },
      {
        path: 'sms-templates',
        /* internal name: '/mailings/sms-templates' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/mailings/sms-templates/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/mailings/sms-templates/index.vue'),
              /* no children */
            },
            _definePage_default_16
          )
        ],
      }
    ],
  },
  {
    path: '/prepared-questions',
    /* internal name: '/prepared-questions' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/prepared-questions/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/prepared-questions/index.vue'),
          /* no children */
        },
        _definePage_default_17
      )
    ],
  },
  {
    path: '/prompts',
    /* internal name: '/prompts' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/prompts/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/prompts/index.vue'),
          /* no children */
        },
        _definePage_default_18
      )
    ],
  },
  {
    path: '/recommendations',
    /* internal name: '/recommendations' */
    /* no component */
    children: [
      {
        path: 'directions',
        /* internal name: '/recommendations/directions' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/recommendations/directions/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/recommendations/directions/index.vue'),
              /* no children */
            },
            _definePage_default_19
          )
        ],
      },
      {
        path: 'institutions',
        /* internal name: '/recommendations/institutions' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/recommendations/institutions/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/recommendations/institutions/index.vue'),
              /* no children */
            },
            _definePage_default_20
          )
        ],
      }
    ],
  },
  {
    path: '/refund-requests',
    /* internal name: '/refund-requests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/refund-requests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/refund-requests/index.vue'),
          /* no children */
        },
        _definePage_default_21
      )
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: 'admins',
        /* internal name: '/settings/admins' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/settings/admins/',
              component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/settings/admins/index.vue'),
              /* no children */
            },
            _definePage_default_22
          )
        ],
      }
    ],
  },
  {
    path: '/test-analytics',
    /* internal name: '/test-analytics' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/test-analytics/[id]',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/test-analytics/[id].vue'),
          /* no children */
        },
        _definePage_default_23
      )
    ],
  },
  {
    path: '/tests',
    /* internal name: '/tests' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/tests/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/tests/index.vue'),
          /* no children */
        },
        _definePage_default_24
      )
    ],
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/users/',
          component: () => import('/builds/raildev/career-guidance/frontend/apps/admin/src/pages/users/index.vue'),
          /* no children */
        },
        _definePage_default_25
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

